import React from 'react';
import { useLocation } from 'react-router-dom';
import { Loader } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import { IBenefitType } from 'src/interfaces';
import { ArrowBack, Container, EmptyContainer, Header, NavTextLink, Title } from './styles';
import { BenefitAgePriceForm, BenefitFixedPriceForm } from '../benefit-price-form';

export const BenefitPricePage = () => {
  const isLoading = false;
  const isFetching = false;
  const location = useLocation();
  const { t } = useTranslation();

  const hasTableBenefits =
    (location.state.selectedBenefitType as IBenefitType).typeBenefit.some(v => v.costCalculationMethod === 'Table') ||
    false;
  return (
    <Container>
      <Header>
        <div style={{ display: 'flex', gap: '30px', justifyContent: 'center', alignItems: 'center' }}>
          <NavTextLink to={`/benefits/edit/prices/${location.state.selectedBenefitType.versionId}?tab=Price`}>
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <Title>{t('benefits.edit.agePrice.headerInformation')}</Title>
        </div>
      </Header>
      {isLoading || isFetching ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <Container>
          {hasTableBenefits ? (
            <BenefitAgePriceForm
              initialValue={location.state.initialValue}
              selectedBenefitType={location.state.selectedBenefitType}
            />
          ) : (
            <BenefitFixedPriceForm
              initialValue={location.state.initialValue}
              selectedBenefitType={location.state.selectedBenefitType}
            />
          )}
        </Container>
      )}
    </Container>
  );
};
